import React from "react";
import { Box, Typography } from "@mui/material";

// Small "On Time / After Delay / Reopened" pill row shown on cards that carry
// completion-timing data (Completed tasks, Approved, Rejected).
const StatusBadgeRow = ({ badges }) => (
  <Box
    display="flex"
    justifyContent="center"
    gap="0.5rem"
    mb="0.6rem"
    mt="0.2rem"
  >
    {badges.map(({ label, value }) => (
      <Box
        key={label}
        sx={{
          border: "1px solid rgba(220, 220, 220, 1)",
          borderRadius: "6px",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
          padding: "0.3rem 0.6rem",
          textAlign: "center",
          minWidth: "4rem",
          flex: 1,
        }}
      >
        <Typography fontSize={"0.65rem"} color={"#888"} lineHeight={1.3}>
          {label}
        </Typography>
        <Typography fontSize={"0.95rem"} fontWeight={700} color={"#111"} lineHeight={1.3}>
          {value}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default StatusBadgeRow;
